import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

import { TRANSACTIONS_QUERY_KEY } from "./useTransactions";
import { ANALYTICS_QUERY_KEY } from "./useSummary";

export type DeleteTransactionVariables = {
  transactionId: string;
};

export function useDeleteTransaction() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, Error, DeleteTransactionVariables>({
    mutationFn: async ({ transactionId }) => {
      const { error } = await client.DELETE(
        "/api/transactions/{transaction_id}",
        { params: { path: { transaction_id: transactionId } } },
      );
      if (error !== undefined) {
        throw new Error(`Failed to delete transaction ${transactionId}`);
      }
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TRANSACTIONS_QUERY_KEY });
      void queryClient.invalidateQueries({ queryKey: ANALYTICS_QUERY_KEY });
    },
  });
}
